var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.5C26.2823 9.28872 31.8715 11.2614 37.5833 11C38.4149 13.8289 38.6694 16.796 38.3315 19.7252C37.9937 22.6543 37.0706 25.4857 35.6169 28.051C34.1632 30.6163 32.2087 32.8632 29.8695 34.6582C27.5303 36.4532 24.8541 37.7597 22 38.5C19.1459 37.7597 16.4697 36.4532 14.1305 34.6582C11.7913 32.8632 9.83675 30.6163 8.38307 28.051C6.9294 25.4857 6.00623 22.6543 5.66842 19.7252C5.33061 16.796 5.58506 13.8289 6.41665 11C12.1284 11.2614 17.7176 9.28872 22 5.5Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.9999C23.0125 21.9999 23.8333 21.1791 23.8333 20.1666C23.8333 19.1541 23.0125 18.3333 22 18.3333C20.9874 18.3333 20.1666 19.1541 20.1666 20.1666C20.1666 21.1791 20.9874 21.9999 22 21.9999Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22V26.5833",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/SecurePayment.bad82c90efecbded2d71b6651d7e16b7.svg";
export { ForwardRef as ReactComponent };